import React from "react";
import {
  SEO,
  PageLayout,
  Background,
  Content,
  OutboundLink,
  ContactForm,
} from "@bluefin/components";
import { Header, List, Button, Grid, div } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";

export default class ProductsAndServicesPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const { fishermanBusiness, fishermanBusinessWebsitePage } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
        />
        <PageLayout
          hero={
            <Background columns={1} stackable={true} className={"about-hero"} />
          }
          subfooter={false}
          className={"about-page products-page"}
        >
          <Content className={"products-content"}>
            <Content.Markup isMarkdown={false} textAlign={"left"} width={8}>
              <Header as={"h1"}>Products & Services</Header>
            </Content.Markup>
            <Content.Markup isMarkdown={false} textAlign={"left"} width={8}>
              <p>Our Products and Services offered include:</p>
              <List
                items={[
                  "Online Ordering: Individual bowls or catering orders",
                  "Walk-ins: Individual bowls or catering orders",
                  "Drop-off Catering",
                  "On-the-Spot Catering",
                ]}
                bulleted={true}
              />
              <p>
                To view our menu options or start a new online order please
                select the button below:
              </p>
              <Button
                primary={true}
                size={"large"}
                to={"https://order.toasttab.com/online/honeydipfingerz"}
                as={OutboundLink}
              >
                Start Order
              </Button>
              <p>
                For Catering Enquiries please fill out the form below with your
                questions and someone from the team will respond within 24
                hours.
              </p>
            </Content.Markup>
          </Content>
          <Grid
            stackable={true}
            className={"component-section-container"}
            verticalAlign={"middle"}
            textAlign={"center"}
          >
            <Grid.Column width={8} textAlign={"left"}>
              <div className={"services-form"}>
                <ContactForm
                  constructMessage={({
                    name,
                    email,
                    subject,
                    phone,
                    description,
                  }) =>
                    `Someone has reached out to you via your website form: Name: ${name}, Email: ${email}, Phone: ${phone}, Subject: ${subject}, Description: ${description}`
                  }
                  fields={[
                    {
                      label: "name",
                      placeholder: "Full Name",
                      type: "input",
                      required: true,
                    },
                    {
                      label: "email",
                      placeholder: "Email",
                      type: "input",
                      inputType: "email",
                      required: true,
                    },
                    {
                      label: "phone",
                      placeholder: "Phone Number",
                      type: "input",
                      required: true,
                    },
                    {
                      label: "subject",
                      placeholder: "Subject",
                      type: "input",
                      required: true,
                    },
                    {
                      label: "description",
                      placeholder: "Description",
                      type: "textarea",
                      required: false,
                    },
                  ]}
                  buttonText={"Send"}
                  centeredHeaders={true}
                  className={""}
                  fluidButton={true}
                  header={""}
                  inline={false}
                  showLabels={true}
                  subheader={""}
                  termsCopy={""}
                  withContainer={true}
                  locationId={fishermanBusiness.primaryLocation._id}
                  businessId={fishermanBusiness._id}
                  businessType={fishermanBusiness.type}
                />
              </div>
            </Grid.Column>
          </Grid>
        </PageLayout>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
      primaryLocation {
        _id
      }
      _id
      type
    }
    fishermanBusinessWebsitePage(title: { eq: "Products And Services" }) {
      title
    }
  }
`;
